// src/services/roomService.js
import apiClient from "./apiClient";

// Use centralized API client for consistent error handling
const api = apiClient;


// Get all rooms
export const getAllRooms = async () => {
  try {
    const response = await api.get('/api/rooms');
    return response.data;
  } catch (error) {
    console.error('Error fetching rooms:', error);
    throw error;
  }
};

export const createRoom = async (roomData) => {
  try {
    const response = await api.post('/api/rooms', roomData);
    return response.data;
  } catch (error) {
    console.error('Error creating room:', error);
    throw error;
  }
};

// Update room
export const updateRoom = async (roomId, roomData) => {
  try {
    const response = await api.put(`/api/rooms/${roomId}`, roomData);
    return response.data;
  } catch (error) {
    console.error('Error updating room:', error);
    throw error;
  }
};

// Delete room
export const deleteRoom = async (roomId) => {
  try {
    const response = await api.delete(`/api/rooms/${roomId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting room:', error);
    throw error;
  }
};

// Create a booking
export const createBooking = async (bookingData) => {
  const response = await api.post('/api/bookings', bookingData);
  return response.data;
};

// Get current userId from token (via /api/auth/me)
export const getCurrentUser = async () => {
  const response = await api.get('/api/auth/me');
  return response.data; // { userId: '...' }
};

export const getRoomById = async (roomId) => {
  try {
    const response = await api.get(`/api/rooms/${roomId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching room:', error);
    throw error;
  }
};

export const getFreeSlotsForDay = async (roomId, date) => {
  try {
    const response = await api.get(`/api/rooms/${roomId}/freeSlots?date=${date}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching free slots:', error);
    throw error;
  }
};

// Room image upload functionality
export const uploadRoomImage = async (roomId, file, imageType = 'gallery') => {
  try {
    const formData = new FormData();
    formData.append('image', file);
    formData.append('imageType', imageType);
    
    const response = await api.post(`/api/rooms/${roomId}/images/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error uploading room image:', error);
    throw error;
  }
};

export const deleteRoomImage = async (roomId, imageId) => {
  try {
    const response = await api.delete(`/api/rooms/${roomId}/images/${imageId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting room image:', error);
    throw error;
  }
};

// File validation utility
export const validateRoomImageFile = (file) => {
  const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
  const maxSize = 5 * 1024 * 1024; // 5MB
  
  if (!allowedTypes.includes(file.type)) {
    throw new Error('Invalid file type. Please upload a JPEG, PNG, or WebP image.');
  }
  
  if (file.size > maxSize) {
    throw new Error('File size exceeds 5MB limit.');
  }
  
  if (file.size < 100) {
    throw new Error('File too small. Please upload a valid image file.');
  }
  
  return true;
};